<template>
  <div class="home-manage">
    <router-view />
  </div>
</template>

<script>
export default { name: 'HomeManageView' }
</script>

<style scoped>
.home-manage { min-height: 100%; }
</style>
